import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    requestKey: null
};
var getCatalogSlice = createSlice({
    name: "getCatalog",
    initialState: initialState,
    reducers: {
        fetchData: function(state, action) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.requestKey = action.payload;
        },
        fetchDataSuccess: function(state, action) {
            if (state.requestKey !== action.payload.requestKey) {
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload.data
            });
        },
        fetchDataFailure: function(state, action) {
            if (state.requestKey !== action.payload) {
                return state;
            }
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getCatalogSlice_actions = getCatalogSlice.actions;
export var fetchData = _getCatalogSlice_actions.fetchData, fetchDataSuccess = _getCatalogSlice_actions.fetchDataSuccess, fetchDataFailure = _getCatalogSlice_actions.fetchDataFailure, resetState = _getCatalogSlice_actions.resetState;
export default getCatalogSlice.reducer;
